<script>
import {ref} from "vue";
import Swal from "sweetalert2";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {Device} from "@capacitor/device";
import FreeWorld from "@/assets/js/FreeWorld";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name: "MyWallet",
  components: {NavbarPage, LoadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let inventory = ref('')

    let data = {
      amount: null
    }

    Device.getInfo().then(info => {
      data.device = info.platform
    });

    let loading = ref(false)

    let wallet = ref({
      mojodi: 0,
      history: []
    })


    function load_wallet() {

      loading.value = true
      FreeWorld.Heisenberg({action: 'history'}, 'user_wallet', true).then((result) => {

        loading.value = false
        let res = result.data
        wallet.value.mojodi = res.mojodi
        wallet.value.history = res.history

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_wallet()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_wallet()
            }
          })
        }
      })
    }

    load_wallet()

    function inventory_increase() {

      if (inventory.value.length == 0) {

        Swal.fire({
          text: "لطفا مبلغ افزایش کیف پول را وارد کنید!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })

      } else if (inventory.value < 9999) {

        Swal.fire({
          text: "حداقل مبلغ افزارش 10,000 تومان می باشد",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })

      } else {

        data.amount = inventory.value

        loading.value = true
        FreeWorld.Heisenberg(data, 'wallet_sharge', true).then((result) => {

          loading.value = false
          let res = result.data
          if (res.status == 'ok') {
            window.location.href = res.url
          } else {
            Swal.fire({
              text: res.event,
              icon: "warning",
              showCancelButton: false,
              confirmButtonText: "متوجه شدم",
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            })
          }

        }).catch((result) => {

          loading.value = false
          if (result.message == 'Network Error') {
            Swal.fire({
              icon: 'error',
              confirmButtonText: 'تلاش مجدد',
              text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
            }).then((result) => {
              if (result.isConfirmed) {
                inventory_increase()
              }
            })
          } else {
            Swal.fire({
              icon: 'error',
              confirmButtonText: 'تلاش مجدد',
              text: '!خطای ارتباط با سرور',
            }).then((result) => {
              if (result.isConfirmed) {
                inventory_increase()
              }
            })
          }
        })

      }

    }

    return {

      wallet,
      loading,
      inventory_increase,
      inventory,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div :class="loading ? 'activeClass' : '' " id="main" class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">
          کیف پول و پرداخت ها
        </p>

        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>

      </div>
    </div>
    <br>
    <br>
    <br>
    <div class="p-body mt-2 w-100 animate__animated animate__fadeIn">

      <div class="">
        <p class="text-end font-4 p-body">
          موجودی کیف پول
        </p>
        <div class="bg-white d-flex justify-content-center align-items-center py-4 rounded-4">
          <span class="font-color-green font-5">تومان</span>
          &nbsp;
          <span class="font-color-green font-4 font-bold">{{ wallet.mojodi.toLocaleString() }}</span>
        </div>
      </div>

      <br>

      <div class="">
        <p class="text-end font-4 p-body">
          شارژ کیف پول
        </p>
        <div class="bg-white d-flex flex-column justify-content-center align-items-center py-4 rounded-4">
          <input v-model="inventory" onkeydown="return event.key != ' '"
                 class="rounded-2 p-2 border-costom text-center bg-main w-50 mb-3 text-center font-4"
                 placeholder="مبلغ مورد نظر" type="number">
          <v-btn @click="inventory_increase" class="w-40 h-75 rounded-2 bg-green p-2 border-costom text-white font-4">
            افزایش موجودی
          </v-btn>
        </div>
      </div>

      <br>
      <hr>

      <div v-if="wallet.history.length != 0 " class="shoping_list animate__animated animate__fadeInUp">

        <div v-for="item in wallet.history" :key="item.id" class="bg-white p-3 rounded-4 mb-2">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex w-40 justify-content-evenly font-5 ">

              <span>{{ item.time }}</span>
              &nbsp;
              <span>{{ item.date }}</span>

            </div>

            <div class="d-flex justify-content-end align-items-center">
              <p :class="item.type === 'increase' ? 'font-color-green' : 'font-color-red' " class="m-0 d-flex font-color-green font-4 mx-2">

                <span class="font-5">تومان</span>
                &nbsp;
                <span class="font-bold">{{ item.amount.toLocaleString() }}</span>

              </p>
              <img v-if="item.type === 'increase' " style="width: 25px" src="../assets/img/plus-bg_green.svg" alt="">
              <img v-else style="width: 25px" src="../assets/img/minus-bg_red.svg" alt="">
            </div>
          </div>

          <hr>

          <p class="m-0 font-5 text-end mx-5">{{ item.info }}</p>

        </div>

      </div>

    </div>
  </div>

  <div :class="loading ? 'activeClass' : '' " id="web" class="bg-main">

    <NavbarPage></NavbarPage>

    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-5 w-75 ma-auto">کیف پول و پرداخت
      ها
    </div>

    <div class="p-body mt-2 m-auto w-75 bg-white rounded-4 p-5 animate__animated animate__fadeIn">

      <div class="">
        <p class="text-end font-4 p-body">
          موجودی کیف پول
        </p>
        <div class="bg-main d-flex justify-content-center align-items-center py-4 rounded-4">
          <span class="font-color-green font-4 font-bold">{{ wallet.mojodi.toLocaleString() }}</span>
          &nbsp;
          <span class="font-color-green font-5">تومان</span>
        </div>
      </div>

      <br>

      <div class="">
        <p class="text-end font-4 p-body">
          شارژ کیف پول
        </p>
        <div class="bg-white d-flex flex-column justify-content-center align-items-center py-4 rounded-4">
          <input v-model="inventory" onkeydown="return event.key != ' '"
                 class="rounded-2 p-2 border-costom text-center bg-main w-50 mb-3 text-center font-4"
                 placeholder="مبلغ مورد نظر" type="number">
          <v-btn @click="inventory_increase" class="w-40 h-75 rounded-2 bg-green p-2 border-costom text-white font-4">
            افزایش موجودی
          </v-btn>
        </div>
      </div>

      <br>
      <hr>

      <div v-if="wallet.history.length != 0 " class="shoping_list animate__animated animate__fadeInUp">

        <div v-for="item in wallet.history" :key="item.id" class="bg-white p-3 shadow rounded-4 mb-4">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex justify-content-end align-items-center">
              <img v-if="item.type === 'increase' " style="width: 25px" src="../assets/img/plus-bg_green.svg" alt="">
              <img v-else style="width: 25px" src="../assets/img/minus-bg_red.svg" alt="">

              <p :class="item.type === 'increase' ? 'font-color-green' : 'font-color-red' " class="m-0 d-flex font-4 mx-2">

                <span class="font-bold">{{ item.amount.toLocaleString() }}</span>
                &nbsp;
                <span class="font-5">تومان</span>

              </p>
            </div>

            <div class="d-flex w-40 justify-content-evenly font-5 ">

              <span>{{ item.time }}</span>
              &nbsp;
              <span>{{ item.date }}</span>

            </div>
          </div>

          <hr>

          <p class="m-0 font-5 text-end">{{ item.info }}</p>

        </div>

      </div>

    </div>
  </div>

</template>

<style scoped>

.shoping_list {
  overflow-y: scroll;
  height: 50vh;
}

.shoping_list::-webkit-scrollbar {
  display: none;
}

</style>